<p class="text-base font-semibold leading-8 text-openflis-600">Unauthorized</p>
<h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
    You are not authorized to view this page.
</h1>
<p class="mt-6 text-base leading-7 text-gray-600">
    Please contact support if you think this is in error.
</p>
@if (errorDescription) {
<p class="mt-4 text-base leading-7 text-gray-600">
    {{ errorDescription }}
</p>
}
@if (referenceNumber) {
<p class="mt-4 text-sm leading-6 text-gray-600">
    Reference number: <span class="font-semibold text-gray-900">{{ referenceNumber }}</span>
</p>
}
